import React from 'react';
import './style.css';

export default function CategoryWrapper({ children }) {
    return (
        <div className="category-wrapper">{children}</div>
    )
}